import { Component, OnInit } from '@angular/core';
import { Validators, FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { SettingService } from '../services/setting.service';
import { HttpErrorResponse } from '@angular/common/http';
import * as $ from 'jquery';
@Component({
  selector: 'app-setting',
  templateUrl: './setting.component.html',
  host: { 'class': 'd-flex flex-column h-100 register-bg' },
  styleUrls: ['./setting.component.css'],
  standalone: true,
  imports: [ReactiveFormsModule]
})
export class SettingComponent implements OnInit {

  updateSettingForm: FormGroup;
  getUserSettingData: any = {};

  successMsg = '';
  successMsgWarning = '';
  //checked: boolean;

  constructor(
    private formBuilder: FormBuilder,
    private settingService: SettingService,
  ) { }


  ngOnInit() {
    sessionStorage.setItem('isNavfromNudgeClicked', 'false');
    this.updateSettingForm = this.formBuilder.group({
      allowNotifications: [true],
      notificationForReport: [true],
      notificationForSolutions: [true],
      notificationForNewsAndFeatures: [true],
      notificationForCoachingAndTips: [true],
      newsLetterSubscription: [true],
      allowEmail: [true],
      allowSMS: [true],
      allowPhone: [true],
    });

    this.userSetting();
    if ((window as any).fcWidget) {
      (window as any).fcWidget.destroy();
    }
    //this.checked = true;
  }

  get settingFormControls() { return this.updateSettingForm.controls; }

  userSetting() {
    this.settingService.getUserSetting()
    .subscribe({
        next: (data: any) => {
      if (data != null) {
        this.updateSettingForm.patchValue(data);
      } else {
        this.settingService.updateUserSetting(this.updateSettingForm.value).subscribe({
        next: (updatedData: any) => {
        },  error: (err: HttpErrorResponse) => { }});
      }
    }, error: (err: HttpErrorResponse) => {

    }});
  }

  allowNotification() {

    if (this.updateSettingForm.controls.allowNotifications.value === true) {
      this.updateSettingForm.patchValue({
        notificationForReport: true,
        notificationForSolutions: true,
        notificationForNewsAndFeatures: true,
        notificationForCoachingAndTips: true,
        allowEmail: true,
        allowSMS: true,
        allowPhone: true
      });
    } else {
      this.updateSettingForm.patchValue({
        notificationForReport: false,
        notificationForSolutions: false,
        notificationForNewsAndFeatures: false,
        notificationForCoachingAndTips: false,
        allowEmail: false,
        allowSMS: false,
        allowPhone: false
      });
    }

    this.updateAll();
  }

  changeSetting() {
    if (this.updateSettingForm.controls.allowEmail.value === true
      || this.updateSettingForm.controls.allowSMS.value === true
      || this.updateSettingForm.controls.allowPhone.value === true) {
      this.updateSettingForm.controls.allowNotifications.setValue(true); 
    } else {
      this.updateSettingForm.controls.allowNotifications.setValue(false);
    }

    this.updateAll();
  }

    
  updateAll() {

    this.settingService.updateUserSetting(this.updateSettingForm.value).subscribe({
        next: (data: any) => {
    }, error :(err: HttpErrorResponse) => {

    }});
  }

}
